import { useEffect, useState } from "react";

export const useDebouncer = (callback, delay = 150) => {
  const [value, setValue] = useState(null);

  const debouncer = (anyValue) => setValue(anyValue);

  useEffect(() => {
    if (value === null) return;

    const timeout = setTimeout(() => callback(value), delay);

    return () => clearTimeout(timeout);
  }, [value]);

  return {
    debouncer
  };
};
